import styled from "styled-components";
import { Z } from "../../global/constants/zIndex";

export const Overlay = styled.div`
  position: fixed;
  inset: 0; /* equivale a top:0; right:0; bottom:0; left:0; */
  z-index: ${Z.MODAL_OVERLAY};
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 145px;
  right: 20px; /* sempre colado à direita */
  bottom: 10.5rem; /* distância do rodapé */

  /* largura responsiva: até 90% da viewport, mas no máximo 500px */
  width: 90vw;
  max-width: 500px;

  max-height: 580px;
  overflow-y: auto;

  background-color: #fff;
  z-index: ${Z.MODAL};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 6px;
  transition: transform 0.3s ease-in-out;

  @media (max-width: 480px) {
    right: 10px; /* diminui o gap em celulares */
    width: 95vw;
  }
`;
